import { Directive, Inject, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { Config } from '@ddt-web/store-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AppConfigurationPropertiesService } from './app-configuration-properties.interface';
import { AppConfigService } from './services/app-config.service';

// eslint-disable-next-line @angular-eslint/directive-selector
@UntilDestroy()
@Directive({ selector: '[appConfig]' })
/**
 * Remove the template content to the DOM based on configuration
 */
export class AppConfigDirective implements OnChanges {
	@Input('appConfig') public elementId: string;

	public storeConfig: Config<any>;
	public appName: string;
	private hasEmbeddedView: boolean = false;

	constructor(
		@Inject(AppConfigurationPropertiesService) private properties,
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		public appConfigService: AppConfigService
	) {
		this.storeConfig = this.properties.store.appConfig;
		this.appName = this.properties.appName;
	}

	public ngOnChanges(): void {
		this.onInputChanged();
	}

	/*
	 * Removes the element from the DOM based on input
	**/
	private onInputChanged(): void {
		this.appConfigService.hasElement(this.storeConfig, this.appName, this.elementId).pipe(untilDestroyed(this)).subscribe(isEnabled => {
			if (isEnabled && !this.hasEmbeddedView) {
				this.viewContainer.createEmbeddedView(this.templateRef);
				this.hasEmbeddedView = true;
			} else if (!isEnabled && this.hasEmbeddedView) {
				this.viewContainer.clear();
				this.hasEmbeddedView = false;
			}
		});
	}
}
